import { createContext, useContext } from 'react'

export type ChatNavigationContextType = {
  show: (id: string) => void
  list: () => void
  new: () => void
}

export const ChatNavigationContext = createContext<ChatNavigationContextType>(undefined)

export const useChatNavigationContext = () => {
  const context = useContext(ChatNavigationContext)

  if (!context) {
    throw new Error('useRoutableChatNavigation must be used within a ChatNavigationContext Provider')
  }

  return context
}
